<template>
  <div
    class="vertically-centered"
    :class="{ 'scrollable': showTestResults }"
    :style="{backgroundImage: `url(${bgImage})`}"
  >
    <DefaultResultsScreen
      v-if="!showTestResults && !customThankYouPage.sys"
      v-on:restart="restartSurvey()"
    ></DefaultResultsScreen>
    <TwoDimensionalTestResult
      v-if="showTestResults"
      v-on:restart="restartSurvey()"
    ></TwoDimensionalTestResult>
    <Screen
      v-if="!showTestResults && customThankYouPage.sys"
      :key="customThankYouPage.sys.id"
      :data="customThankYouPage"
      :full-width="true"
      v-on:next="next($event)"
      v-on:restart="restartSurvey()"
    ></Screen>
  </div>
</template>

<script>
export default {
  props: [ 'bgImage' ],

  name: 'Results',

  components: {
    Screen: () => import('Components/questions/Screen'),
    DefaultResultsScreen: () => import('Components/base/DefaultResultsScreen'),
    TwoDimensionalTestResult: () => import('Components/base/TwoDimensionalTestResult')
  },

  computed: {
    customThankYouPage () {
      return this.$store.state.survey.customThankYouPage || {}
    },
    weightedTestResults () {
      return this.$store.state.survey.weightedTestResults
    },
    showTestResults () {
      return this.$store.state.survey.showTestResults
    }
  },

  methods: {
    restartSurvey () {
      this.$store.commit('CLEAR_FORM')
      this.$router.push({ name: 'survey', params: { sid: process.env.VUE_APP_DEFAULT_SID, qid: 0 } })
    }
  }
}
</script>

<style scoped lang="scss">
.full-areax {
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  background-position: center;
  background-attachment: fixed;
  background-size: cover;
}
</style>
